/* eslint-disable keyword-spacing */
import { Provider } from 'react-redux';
import { store } from './store/store';

import ErrorBoundary from './components/error-boundary';
import Main from './components/app';

import 'react-toastify/dist/ReactToastify.css';
import 'rsuite/dist/rsuite.min.css';
import './assets/styles/index.scss';

const App = () =>
    <ErrorBoundary>
        <Provider store={store}>
            <Main />
        </Provider>
    </ErrorBoundary>
;

export default App;
